<script lang="ts">
  import type { FormComponentSlotProps } from "@inertiajs/core"
  import { Form } from "@inertiajs/svelte"
  import { LoaderCircle } from "@lucide/svelte"

  import InputError from "@/components/input-error.svelte"
  import TextLink from "@/components/text-link.svelte"
  import { Button } from "@/components/ui/button"
  import { Input } from "@/components/ui/input"
  import { Label } from "@/components/ui/label"
  import AuthBase from "@/layouts/auth-layout.svelte"
  import { newIdentityPasswordResetPath, signInPath } from "@/routes"
</script>

<svelte:head>
  <title>Log in - Chorizo</title>
</svelte:head>

<AuthBase
  title="Log in to your account"
  description="Enter your email and password below to log in"
>
  <Form
    method="post"
    action={signInPath()}
    resetOnSuccess={["password"]}
    class="flex flex-col gap-6"
  >
    {#snippet children({ processing, errors }: FormComponentSlotProps)}
      <div class="grid gap-6">
        <div class="grid gap-2">
          <Label for="email">Email address</Label>
          <Input
            id="email"
            name="email"
            type="email"
            required
            autofocus
            tabindex={1}
            autocomplete="email"
            placeholder="email@example.com"
          />
          <InputError message={errors.email} />
        </div>

        <div class="grid gap-2">
          <div class="flex items-center justify-between">
            <Label for="password">Password</Label>
            <TextLink
              href={newIdentityPasswordResetPath()}
              class="text-sm"
              tabindex={5}
            >
              Forgot password?
            </TextLink>
          </div>
          <Input
            id="password"
            name="password"
            type="password"
            required
            tabindex={2}
            autocomplete="current-password"
            placeholder="Password"
          />
          <InputError message={errors.password} />
        </div>

        <Button
          type="submit"
          class="mt-4 w-full"
          tabindex={4}
          disabled={processing}
        >
          {#if processing}
            <LoaderCircle class="h-4 w-4 animate-spin" />
          {/if}
          Log in
        </Button>
      </div>
    {/snippet}
  </Form>
</AuthBase>
